<template>
  <main class="main">
    <div class="content container">
      <MainHeading> Вход в личный кабинет </MainHeading>

      <div class="content__container">
        <p class="content__slogan p-reset">
          Нет личного кабинета?
          <router-link
            :to="{ name: 'register' }"
            class="content__link link-reset"
          >
            Зарегистрируйтесь прямо&nbsp;сейчас
          </router-link>
        </p>

        <form
          class="content__form form personal"
          action="#"
          @submit.prevent="doLogin()"
        >
          <label class="form__label">
            <input
              class="form__input"
              type="text"
              name="login"
              v-model="formData.username"
              placeholder="E-mail"
            />
          </label>
          <label class="form__label">
            <input
              class="form__input"
              :type="isPasswordHide ? 'password' : 'text'"
              name="password"
              v-model="formData.password"
              placeholder="Пароль"
            />
            <span
              class="form__label-password-icon"
              @click="isPasswordHide = !isPasswordHide"
            >
              <svg>
                <use
                  :xlink:href="isPasswordHide ? '#icon-show' : '#icon-hide'"
                ></use>
              </svg>
            </span>
            <span v-if="isLoginError" class="form__login-error">Неверный логин и/или пароль</span>
          </label>
          <button class="form__submit btn-reset" type="submit">Войти</button>
          <span class="form__message" v-if="formDataSending">Загрузка...</span>
          <span class="form__message" v-else-if="formDataSendingError">Что-то пошло не так.</span>
          <span class="form__message" v-else-if="formDataSendingSuccess">Успешно!</span>
        </form>
      </div>
    </div>
  </main>
</template>

<style src="@/assets/styles/register-page.css" scoped>
</style>

<script>
import MainHeading from '@/components/MainHeading.vue'
import { API_BASE_URL } from '@/config'
export default {
  data () {
    return {
      isPasswordHide: true,
      isLoginError: false,

      formData: {
        username: '',
        password: ''
      },

      formDataSending: false,
      formDataSendingError: false,
      formDataSendingSuccess: false

    }
  },
  components: { MainHeading },
  methods: {
    async doLogin () {
      this.formDataSending = true
      this.formDataSendingError = false
      this.formDataSendingSuccess = false
      this.isLoginError = false

      const response = await fetch(`${API_BASE_URL}/api/login`, {
        method: 'POST',
        body: JSON.stringify(this.formData),
        headers: {
          'Content-Type': 'application/json'
        }
      })

      if (response.ok) {
        const data = await response.json()
        this.formDataSending = false
        this.formDataSendingSuccess = true
        localStorage.setItem('userToken', JSON.stringify(data.token))
        this.$router.push({ name: 'user' })
      } else if (response.status === 401) {
        this.formDataSending = false
        this.isLoginError = true
      } else {
        this.formDataSending = false
        this.formDataSendingError = true
      }
    }
  }
}
</script>
